import React, { useEffect } from "react";
import { setCookie } from "@/lib/cookies";

const OauthSuccess = () => {
  // In your frontend, create a route to handle /auth/success
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (token) {
      setCookie("token", token);
      // Clear the URL params before redirecting
      window.history.replaceState({}, document.title, window.location.pathname);
      // Redirect to your app's main page
      window.location.href = "/dashboard";
    }
  }, []);
  return <div />;
};

export default OauthSuccess;
